import NewMainVerify from '@comp/NewVerify/newVerifyMain';
import CustomFailed from '@root/components/CustomFailed';
import CustomSuccess from '@root/components/CustomSuccess';
import {
  formVerifyData,
  getCreditplusContentData
} from '@root/constants/formData';
import {
  creditPlusVerify,
  creditPlusVerifyFailed,
  creditPlusVerifySuccess
} from '@root/constants/paths';
import icon from '@root/images/creditPlus/logo.svg';

const { main } = getCreditplusContentData();

export const getCreditPlusVerifyRoutes = () => [
  {
    path: creditPlusVerify(),
    element: (
      <NewMainVerify
        mainContent={main}
        formData={formVerifyData}
        merchantIcon={icon}
        redirectPaths={{
          success: creditPlusVerifySuccess,
          failed: creditPlusVerifyFailed
        }}
      />
    )
  },
  {
    path: creditPlusVerifySuccess(),
    element: <CustomSuccess />
  },
  {
    path: creditPlusVerifyFailed(),
    element: <CustomFailed />
  }
];
